/**
 * 簽核流程客製化配置
 *
 * 用於控制簽核流程中的顯示選項和通知行為
 * 不同客戶（companyid）可以有不同的配置
 */
export interface ApprovalWorkflowConfig {
  id: string;                    // 固定值: "approval-workflow-config"
  companyid: string;             // 公司 ID（partition key）

  // 退回選項控制
  rejectOptions: {
    enableCompleteReject: boolean;  // true = 顯示完全拒絕, false = 隱藏
  };

  // 通知行為控制
  notificationBehavior: {
    // 退回給申請人時，是否通知中間關卡簽核者
    notifyIntermediateApproversOnReturnToSubmitter: boolean;
    // 簽核完成後，是否通知申請人
    notifySubmitterOnCompletion: boolean;
  };

  createdAt?: string;            // ISO 8601 格式
  updatedAt?: string;            // ISO 8601 格式
}

/**
 * 預設配置
 *
 * 當 API 失敗或配置不存在時使用此預設值
 * 預設值維持既有行為，確保向下相容性
 */
export const DEFAULT_APPROVAL_WORKFLOW_CONFIG: ApprovalWorkflowConfig = {
  id: 'approval-workflow-config',
  companyid: '',
  rejectOptions: {
    enableCompleteReject: false  // 預設不顯示「完全拒絕」
  },
  notificationBehavior: {
    notifyIntermediateApproversOnReturnToSubmitter: false,  // 預設不通知中間關卡
    notifySubmitterOnCompletion: true  // 預設通知申請人完成
  }
};
